<template>
    <div class="row">
        <div class="col-12">
            <ibox :title="'Przymierzalnia'">
                <template slot="tools">
                    <router-link :to="`/przymierzalnia/${$route.params.env}/kategorie/dodaj`" class="btn btn-primary btn-xs">
                        Dodaj kategorię
                        <i class="fas fa-plus"></i>
                    </router-link>
                </template>
                <template slot="content" slot-scope="{ setLoading }">
                    <data-tables
                        :url="`vnfr/${$route.params.env}/categories/list`"
                        :columns_list="columns_list"
                        @loading="setLoading"
                    />
                </template>
            </ibox>
        </div>
    </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import DataTables from '@/components/DataTables'

export default {
    name: 'CategoriesList',
    components: {
        Ibox,
        DataTables
    },
    data() {
        return {
            excel: true,
            columns_list: [
                {
                    key: 'id',
                    name: this.$t( 'edit' ),
                    filter: 'btn',
                    btn: a => `<a href="#/przymierzalnia/${this.$route.params.env}/kategorie/${a}"><i class="fa fa-edit"></i></a>`
                },
                {
                    key: 'sub',
                    name: 'Subkategoria',
                    filter: 'boolean',
                    type: 'text'
                },
                {
                    key: 'img_url',
                    name: 'Zdjęcie',
                    filter: 'image',
                    width: '100'
                },
                {
                    key: 'name',
                    name: 'Nazwa',
                    type: 'text',
                    sortable: true
                }
            ]
        }
    }
}
</script>
